export default {
  actions_menu: "Menu de ações",

  actions: {
    activate: "Ativar",
    coverage: "Abrangências",
    districts: "Distritos",
    delete: "Deletar",
    remove: "Remover",
    inactivate: "Inativar",
    permissions: "Permissões",
    update: "Editar",
    add: "Adicionar",
    new: "Novo",
    bind_protocol: "Vincular protocolo",
    binded: "Vinculados",
    procedures: "Procedimentos",
    upload_attachment: "Enviar anexo",
    view_attachment: "Visualizar anexo",
    download_attachment: "Baixar anexo",
    delete_attachment: "Deletar anexo",
    remove_attachment: "Remover anexo",
    details: "Detalhes",
    cancel: "Cancelar",
    visualize: "Visualizar",
    review: "Avaliar",
    month: "Mês",
    week: "Semana",
    day: "Dia",
    insert_attachment: "Inserir anexo",
    select: "Selecionar",
    regulate: "Regular",
    cancel_solicitate: "Cancelar solicitação",
    ppp: "Exames de Imagem",
    close: "Encerrar",
    attendance: "Atendimento",
    new_register: "Novo registro",
    skip_to_solicitation: "Pular para solicitação",
    change_service_status: "Alterar status do atendimento",
    print: "Impr. normal",
    print_overshadowed: "Impr. ofuscada",
    exclusivity: "Exclusividade",
    reevaluate: "Reavaliar",
    egress: "Solic. atendimento egresso",
    unacon: "Solic. atendimento Oncologia (Unacon/Cacon)",
    change_status: "Alterar status",
    solicitations: "Solicitações",
    outdated_patient: "Cad. Paciente desatualizado",
    rescheduling: "Reagendamento",
    return_regulation: "Retornar para regulação",
    reopening: "Reabertura",
    remove_unity_bind: "Remover unidade vinculada",
    duplicate: "Duplicar",
    bind: "Vincular",
    reference: "Referência",
    remove_reference: "Remover referência",
    include_cid: "Incluir CID",
    diagnosis: "Diagnóstico",
    date_of_treatment_start: "Data de início do tratamento",
    report_discharge: "Reportar alta",
    new_treatment: "Novo tratamento",
  },
};
